/** Figma `17:537` — Sensemaker Overview page layout tokens. */
export { APP_SHELL_PAGE_PADDING_PX as SENSEMAKER_OVERVIEW_PAGE_PADDING_PX } from '@/shared/layout/appShellPageLayout'

/** Figma `17:537` — vertical spacing between overview blocks */
export const SENSEMAKER_OVERVIEW_BREADCRUMB_TO_PROFILE_GAP_PX = 33
export const SENSEMAKER_OVERVIEW_PROFILE_TO_METRICS_GAP_PX = 24
export const SENSEMAKER_OVERVIEW_METRICS_TO_CHARTS_GAP_PX = 26
export const SENSEMAKER_OVERVIEW_CHARTS_TO_CAMPAIGNS_GAP_PX = 40
export const SENSEMAKER_OVERVIEW_MAJOR_SECTION_GAP_PX = 40
/** Section title → first content row (payment tiles, team cards). */
export const SENSEMAKER_OVERVIEW_SECTION_TITLE_TO_CONTENT_GAP_PX = 24
/** Payment summary tiles → history table (`17:874` → `17:837`). */
export const SENSEMAKER_OVERVIEW_PAYMENT_TILES_TO_TABLE_GAP_PX = 20
/** Payment summary → Team Members section. */
export const SENSEMAKER_OVERVIEW_PAYMENT_TO_TEAM_GAP_PX = 56

/** @deprecated Use per-block tokens above; kept for skeleton / major block rhythm. */
export const SENSEMAKER_OVERVIEW_SECTION_GAP_PX = SENSEMAKER_OVERVIEW_MAJOR_SECTION_GAP_PX

/** Figma `17:617` — overview page title + breadcrumb */
export const SENSEMAKER_OVERVIEW_PAGE_TITLE_COLOR = '#23262f'
export const SENSEMAKER_OVERVIEW_PAGE_TITLE_SIZE_PX = 24
export const SENSEMAKER_OVERVIEW_PAGE_TITLE_LINE_HEIGHT_PX = 32
export const SENSEMAKER_OVERVIEW_PAGE_TITLE_LETTER_SPACING_PX = 0.0703
export const SENSEMAKER_OVERVIEW_PAGE_TITLE_TO_BREADCRUMB_GAP_PX = 4
export const SENSEMAKER_OVERVIEW_BREADCRUMB_PADDING_Y_PX = 10
export const SENSEMAKER_OVERVIEW_BREADCRUMB_GAP_PX = 10
export const SENSEMAKER_OVERVIEW_BREADCRUMB_LINK_COLOR = '#4a5565'
export const SENSEMAKER_OVERVIEW_BREADCRUMB_CURRENT_COLOR = '#23262f'
export const SENSEMAKER_OVERVIEW_BREADCRUMB_FONT_SIZE_PX = 14
export const SENSEMAKER_OVERVIEW_BREADCRUMB_LINE_HEIGHT_PX = 20
export const SENSEMAKER_OVERVIEW_BREADCRUMB_LETTER_SPACING_PX = -0.1504
export const SENSEMAKER_OVERVIEW_BREADCRUMB_CHEVRON_SIZE_PX = 20
export const SENSEMAKER_OVERVIEW_BREADCRUMB_BACK_GAP_PX = 8

/** Shared section / page title — matches `Sensemaker List` (`17:617`). */
export const sensemakerOverviewSectionTitleSx = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 700,
  fontSize: `${SENSEMAKER_OVERVIEW_PAGE_TITLE_SIZE_PX}px`,
  lineHeight: `${SENSEMAKER_OVERVIEW_PAGE_TITLE_LINE_HEIGHT_PX}px`,
  letterSpacing: `${SENSEMAKER_OVERVIEW_PAGE_TITLE_LETTER_SPACING_PX}px`,
  color: SENSEMAKER_OVERVIEW_PAGE_TITLE_COLOR,
  m: 0,
} as const

/** Figma `17:555` — profile header card */
export const SENSEMAKER_OVERVIEW_PROFILE_CARD_PADDING_X_PX = 23
export const SENSEMAKER_OVERVIEW_PROFILE_CARD_PADDING_TOP_PX = 15
export const SENSEMAKER_OVERVIEW_PROFILE_CARD_PADDING_BOTTOM_PX = 16
export const SENSEMAKER_OVERVIEW_PROFILE_CARD_RADIUS_PX = 14
export const SENSEMAKER_OVERVIEW_PROFILE_CARD_BORDER = '1px solid #e2e8f0'
export const SENSEMAKER_OVERVIEW_PROFILE_CARD_BG = 'rgba(255,255,255,0.3)'
export const SENSEMAKER_OVERVIEW_PROFILE_AVATAR_SIZE_PX = 40
export const SENSEMAKER_OVERVIEW_PROFILE_AVATAR_GAP_PX = 16
export const SENSEMAKER_OVERVIEW_PROFILE_NAME_TYPE_GAP_PX = 12
export const SENSEMAKER_OVERVIEW_PROFILE_TITLE_SUBTITLE_GAP_PX = 5
export const SENSEMAKER_OVERVIEW_PROFILE_HEADER_TO_TOKEN_GAP_PX = 24
export const SENSEMAKER_OVERVIEW_PROFILE_TOKEN_LABEL_TO_BAR_GAP_PX = 8
export const SENSEMAKER_OVERVIEW_PROFILE_BAR_TO_TEAM_GAP_PX = 8
export const SENSEMAKER_OVERVIEW_PROFILE_TOKEN_BAR_HEIGHT_PX = 4
export const SENSEMAKER_OVERVIEW_PROFILE_BADGE_HEIGHT_PX = 26
export const SENSEMAKER_OVERVIEW_PROFILE_STATUS_TO_PACKAGE_GAP_PX = 14

/** Figma `17:576` — four metric tiles row */
export const SENSEMAKER_OVERVIEW_METRIC_TILE_HEIGHT_PX = 174
export const SENSEMAKER_OVERVIEW_METRIC_TILE_RADIUS_PX = 10
export const SENSEMAKER_OVERVIEW_METRIC_TILE_BORDER = '1px solid #e2e8f0'
export const SENSEMAKER_OVERVIEW_METRIC_TILE_PADDING_PX = 24
export const SENSEMAKER_OVERVIEW_METRIC_TILE_GAP_PX = 24
export const SENSEMAKER_OVERVIEW_METRIC_ICON_SIZE_PX = 48
export const SENSEMAKER_OVERVIEW_METRIC_ICON_INNER_PX = 24
export const SENSEMAKER_OVERVIEW_METRIC_ICON_RADIUS_PX = 10
export const SENSEMAKER_OVERVIEW_METRIC_ICON_TO_VALUE_GAP_PX = 16
export const SENSEMAKER_OVERVIEW_METRIC_VALUE_TO_LABEL_GAP_PX = 4

/** Figma `17:890` — Token Burn Trend chart card */
export const SENSEMAKER_OVERVIEW_BURN_CHART_HEIGHT_PX = 400
export const SENSEMAKER_OVERVIEW_BURN_CHART_RADIUS_PX = 14
export const SENSEMAKER_OVERVIEW_BURN_CHART_SHADOW =
  '0px 1.418px 4.255px rgba(13, 10, 44, 0.08)'
export const SENSEMAKER_OVERVIEW_BURN_CHART_PADDING_PX = 24
/** Figma `17:890` title → chart plot area (matches split chart title gap). */
export const SENSEMAKER_OVERVIEW_BURN_CHART_TITLE_TO_GRAPH_GAP_PX = 26
export const SENSEMAKER_OVERVIEW_BURN_CHART_TITLE_COLOR = '#1e1b39'
export const SENSEMAKER_OVERVIEW_BURN_CHART_AXIS_TICK_COLOR = '#615e83'
export const SENSEMAKER_OVERVIEW_BURN_CHART_GRID_COLOR = '#e8e8ef'
export const SENSEMAKER_OVERVIEW_BURN_CHART_EMPTY_ICON_BG = '#bababa'

/** Figma `17:806` — Instrument Type Split chart card */
export const SENSEMAKER_OVERVIEW_SPLIT_CHART_HEIGHT_PX = 400
export const SENSEMAKER_OVERVIEW_SPLIT_CHART_RADIUS_PX = 10
export const SENSEMAKER_OVERVIEW_SPLIT_CHART_BORDER = '1px solid #e6e8ec'
export const SENSEMAKER_OVERVIEW_SPLIT_CHART_PADDING_PX = 24
export const SENSEMAKER_OVERVIEW_SPLIT_CHART_TITLE_COLOR = '#1e1b39'
export const SENSEMAKER_OVERVIEW_SPLIT_SEGMENT_COLORS = ['#f77b03', '#fa8e21', '#fdb269'] as const
/** Non-hovered doughnut segments on chart hover — nearly invisible. */
export const SENSEMAKER_OVERVIEW_SPLIT_SEGMENT_DIM_OPACITY = 0.08
export const SENSEMAKER_OVERVIEW_SPLIT_LEGEND_TEXT_COLOR = '#6b7280'
/** Figma `17:813` — horizontal pill swatch, not a square */
export const SENSEMAKER_OVERVIEW_SPLIT_LEGEND_SWATCH_WIDTH_PX = 21.314
export const SENSEMAKER_OVERVIEW_SPLIT_LEGEND_SWATCH_HEIGHT_PX = 9.325
export const SENSEMAKER_OVERVIEW_SPLIT_LEGEND_SWATCH_RADIUS_PX = 2.664
export const SENSEMAKER_OVERVIEW_SPLIT_LEGEND_SWATCH_TO_LABEL_GAP_PX = 9
export const SENSEMAKER_OVERVIEW_SPLIT_LEGEND_ROW_GAP_PX = 9
/** Figma `17:825` — doughnut size; `17:810` legend sits to the right, vertically centered. */
export const SENSEMAKER_OVERVIEW_SPLIT_CHART_DONUT_SIZE_PX = 288
/** Smaller cutout % = thicker ring (Chart.js doughnut). */
export const SENSEMAKER_OVERVIEW_SPLIT_CHART_DONUT_CUTOUT = '58%'
export const SENSEMAKER_OVERVIEW_SPLIT_CHART_BODY_GAP_PX = 80
export const SENSEMAKER_OVERVIEW_SPLIT_CHART_DONUT_OFFSET_LEFT_PX = 30
export const SENSEMAKER_OVERVIEW_SPLIT_CHART_TITLE_TO_BODY_GAP_PX = 26
export const SENSEMAKER_OVERVIEW_CHART_HEIGHT_PX = 400
export const SENSEMAKER_OVERVIEW_CHART_GAP_PX = 24
export const SENSEMAKER_OVERVIEW_ACCORDION_RADIUS_PX = 10

/** Figma `17:612` — Campaigns section heading (title uses `sensemakerOverviewSectionTitleSx`) */
export const SENSEMAKER_OVERVIEW_CAMPAIGNS_SUBTITLE_COLOR = '#6b7a90'
export const SENSEMAKER_OVERVIEW_CAMPAIGNS_SUBTITLE_SIZE_PX = 14
export const SENSEMAKER_OVERVIEW_CAMPAIGNS_SUBTITLE_LINE_HEIGHT_PX = 21
export const SENSEMAKER_OVERVIEW_CAMPAIGNS_SUBTITLE_MAX_WIDTH_PX = 392
/** Figma gap from header group (`17:612`) to first campaign card (`17:627` at y=1046). */
export const SENSEMAKER_OVERVIEW_CAMPAIGNS_HEADER_TO_LIST_GAP_PX = 25

/** Figma `17:627` — campaign master accordion card */
export const SENSEMAKER_OVERVIEW_CAMPAIGN_CARD_BORDER = '1px solid #e2e8f0'
export const SENSEMAKER_OVERVIEW_CAMPAIGN_CARD_RADIUS_PX = 10
export const SENSEMAKER_OVERVIEW_CAMPAIGN_CARD_PADDING_X_PX = 23
export const SENSEMAKER_OVERVIEW_CAMPAIGN_CARD_HEADER_PADDING_Y_PX = 11
export const SENSEMAKER_OVERVIEW_CAMPAIGN_CARD_COLLAPSED_MIN_HEIGHT_PX = 75

/** Figma `17:796` — collapsed campaign master card */
export const SENSEMAKER_OVERVIEW_CAMPAIGN_CARD_COLLAPSED_HEIGHT_PX = 75
export const SENSEMAKER_OVERVIEW_CAMPAIGN_CARD_COLLAPSED_PADDING_X_PX = 24
export const SENSEMAKER_OVERVIEW_CAMPAIGN_CARD_COLLAPSED_PADDING_TOP_PX = 12
export const SENSEMAKER_OVERVIEW_CAMPAIGN_CARD_COLLAPSED_PADDING_BOTTOM_PX = 11
export const SENSEMAKER_OVERVIEW_CAMPAIGN_CARD_COLLAPSED_HEADER_HEIGHT_PX = 52
export const SENSEMAKER_OVERVIEW_CAMPAIGN_CARD_GAP_PX = 20
export const SENSEMAKER_OVERVIEW_CAMPAIGN_TITLE_COLOR = '#23262f'
export const SENSEMAKER_OVERVIEW_CAMPAIGN_TITLE_SIZE_PX = 18
export const SENSEMAKER_OVERVIEW_CAMPAIGN_TITLE_LINE_HEIGHT_PX = 28
export const SENSEMAKER_OVERVIEW_CAMPAIGN_TITLE_LETTER_SPACING_PX = -0.4395
export const SENSEMAKER_OVERVIEW_CAMPAIGN_CREATED_COLOR = '#6b7a90'
export const SENSEMAKER_OVERVIEW_CAMPAIGN_CREATED_SIZE_PX = 13
export const SENSEMAKER_OVERVIEW_CAMPAIGN_CREATED_LINE_HEIGHT_PX = 19.5
export const SENSEMAKER_OVERVIEW_CAMPAIGN_TITLE_TO_CREATED_GAP_PX = 4
export const SENSEMAKER_OVERVIEW_CAMPAIGN_HEADER_TO_LOI_GAP_PX = 17
export const SENSEMAKER_OVERVIEW_CAMPAIGN_STATUS_BADGE_HEIGHT_PX = 26

export const SENSEMAKER_OVERVIEW_CAMPAIGN_STATUS_STYLES = {
  active: { bg: '#d1fae5', border: '#10b981', color: '#065f46' },
  completed: { bg: '#e3f2fd', border: '#3285d7', color: '#1976d2' },
  draft: { bg: '#edf2f8', border: '#707f8b', color: '#707f8b' },
} as const

/** Figma `17:636` — LOI sub-card inside expanded campaign */
export const SENSEMAKER_OVERVIEW_LOI_CARD_BORDER = '1px solid #e4e9f0'
export const SENSEMAKER_OVERVIEW_LOI_CARD_RADIUS_PX = 14
export const SENSEMAKER_OVERVIEW_LOI_CARD_PADDING_X_PX = 15
export const SENSEMAKER_OVERVIEW_LOI_TITLE_COLOR = '#23262f'
export const SENSEMAKER_OVERVIEW_LOI_TITLE_SIZE_PX = 14
export const SENSEMAKER_OVERVIEW_LOI_TITLE_LINE_HEIGHT_PX = 28
export const SENSEMAKER_OVERVIEW_LOI_HEADER_PADDING_Y_PX = 10
export const SENSEMAKER_OVERVIEW_LOI_HEADER_GAP_PX = 10
export const SENSEMAKER_OVERVIEW_LOI_INSTRUMENT_COUNT_BADGE_BG = '#e7fbff'
export const SENSEMAKER_OVERVIEW_LOI_INSTRUMENT_COUNT_BADGE_BORDER = '0.5px solid #008cd0'
export const SENSEMAKER_OVERVIEW_LOI_INSTRUMENT_COUNT_BADGE_COLOR = '#3b82f6'
export const SENSEMAKER_OVERVIEW_LOI_STAT_TILE_BG = '#f5f4ed'
export const SENSEMAKER_OVERVIEW_LOI_STAT_TILE_RADIUS_PX = 12
export const SENSEMAKER_OVERVIEW_LOI_STAT_TILE_HEIGHT_PX = 91
export const SENSEMAKER_OVERVIEW_LOI_STAT_TILE_PADDING_PX = 16
export const SENSEMAKER_OVERVIEW_LOI_STAT_TILE_GAP_PX = 20
export const SENSEMAKER_OVERVIEW_LOI_STAT_LABEL_COLOR = '#0f172a'
export const SENSEMAKER_OVERVIEW_LOI_STAT_VALUE_COLOR = '#101828'
export const SENSEMAKER_OVERVIEW_LOI_STAT_LABEL_SIZE_PX = 14
export const SENSEMAKER_OVERVIEW_LOI_STAT_VALUE_SIZE_PX = 18
export const SENSEMAKER_OVERVIEW_LOI_HEADER_TO_STATS_GAP_PX = 10
export const SENSEMAKER_OVERVIEW_LOI_STATS_TO_TABLE_GAP_PX = 20

/** Figma `17:665` — instrument table inside LOI */
export const SENSEMAKER_OVERVIEW_INSTRUMENT_TABLE_BORDER = '1px solid #e5e7eb'
export const SENSEMAKER_OVERVIEW_INSTRUMENT_TABLE_RADIUS_PX = 10
export const SENSEMAKER_OVERVIEW_INSTRUMENT_TABLE_HEADER_BG = '#e1e7f3'
export const SENSEMAKER_OVERVIEW_INSTRUMENT_TABLE_HEADER_HEIGHT_PX = 49
export const SENSEMAKER_OVERVIEW_INSTRUMENT_TABLE_HEADER_COLOR = '#4a5565'
export const SENSEMAKER_OVERVIEW_INSTRUMENT_TABLE_ROW_HEIGHT_PX = 61
export const SENSEMAKER_OVERVIEW_INSTRUMENT_TABLE_ROW_BORDER = '1px solid #e5e7eb'
export const SENSEMAKER_OVERVIEW_INSTRUMENT_TABLE_CELL_COLOR = '#0f172a'

export const SENSEMAKER_OVERVIEW_INSTRUMENT_STATUS_STYLES = {
  active: { bg: '#d1fae5', border: '#10b981', color: '#065f46' },
  complete: { bg: '#e3f2fd', border: '#3285d7', color: '#1976d2' },
  expire: { bg: '#fee2e2', border: '#ef4444', color: '#b91c1c' },
  draft: { bg: '#edf2f8', border: '#707f8b', color: '#707f8b' },
} as const

export const SENSEMAKER_OVERVIEW_INSTRUMENT_TYPE_REWARD_STYLES = {
  bg: '#e3f2fd',
  border: '#3285d7',
  color: '#1976d2',
} as const

export const SENSEMAKER_OVERVIEW_INSTRUMENT_TYPE_NO_REWARD_STYLES = {
  bg: '#edf2f8',
  border: '#707f8b',
  color: '#707f8b',
} as const

/** Figma `17:874` — payment summary tiles row */
export const SENSEMAKER_OVERVIEW_PAYMENT_TILE_GAP_PX = 20
export const SENSEMAKER_OVERVIEW_PAYMENT_TILE_HEIGHT_PX = 99
export const SENSEMAKER_OVERVIEW_PAYMENT_TILE_RADIUS_PX = 8
export const SENSEMAKER_OVERVIEW_PAYMENT_TILE_VALUE_COLOR = '#0b1c30'
export const SENSEMAKER_OVERVIEW_PAYMENT_TILE_VALUE_SIZE_PX = 30
export const SENSEMAKER_OVERVIEW_PAYMENT_TILE_VALUE_LINE_HEIGHT_PX = 32
export const SENSEMAKER_OVERVIEW_PAYMENT_TILE_LABEL_COLOR = '#3f4850'
export const SENSEMAKER_OVERVIEW_PAYMENT_TILE_LABEL_SIZE_PX = 14
export const SENSEMAKER_OVERVIEW_PAYMENT_TILE_LABEL_TRACKING_PX = 0.12
export const SENSEMAKER_OVERVIEW_PAYMENT_TILE_VALUE_TO_LABEL_GAP_PX = 4.5

export const SENSEMAKER_OVERVIEW_PAYMENT_TILE_STYLES = {
  package: {
    bg: '#e7fbff',
    border: '#c7ebf9',
    paddingLeftPx: 9,
    paddingRightPx: 16,
    labelLineHeightPx: 14,
  },
  instrumentCost: {
    bg: '#ffebee',
    border: '#ffd9ea',
    paddingLeftPx: 11,
    paddingRightPx: 16,
    labelLineHeightPx: 14,
  },
  publicationCost: {
    bg: 'rgba(245, 158, 11, 0.2)',
    border: '#fbe797',
    paddingLeftPx: 11,
    paddingRightPx: 16,
    labelLineHeightPx: 16,
  },
} as const

export type SensemakerOverviewPaymentTileVariant = keyof typeof SENSEMAKER_OVERVIEW_PAYMENT_TILE_STYLES

/** Figma `17:837` — payment history table */
export const SENSEMAKER_OVERVIEW_PAYMENT_TABLE_RADIUS_PX = 10
export const SENSEMAKER_OVERVIEW_PAYMENT_TABLE_EMPTY_COLOR = '#64748b'
export const SENSEMAKER_OVERVIEW_PAYMENT_TABLE_EMPTY_MIN_HEIGHT_PX = 60
export const SENSEMAKER_OVERVIEW_PAYMENT_TABLE_COLUMNS =
  'minmax(140px, 1.1fr) minmax(220px, 2fr) minmax(120px, 1fr) minmax(120px, 1fr)'

/** Figma `17:852` — team member cards list */
export const SENSEMAKER_OVERVIEW_TEAM_CARD_GAP_PX = 20
export const SENSEMAKER_OVERVIEW_TEAM_CARD_BORDER = '1px solid #e2e8f0'
export const SENSEMAKER_OVERVIEW_TEAM_CARD_RADIUS_PX = 10
export const SENSEMAKER_OVERVIEW_TEAM_CARD_HEIGHT_PX = 75
export const SENSEMAKER_OVERVIEW_TEAM_CARD_PADDING_X_PX = 23
export const SENSEMAKER_OVERVIEW_TEAM_CARD_PADDING_Y_PX = 11
export const SENSEMAKER_OVERVIEW_TEAM_AVATAR_SIZE_PX = 40
export const SENSEMAKER_OVERVIEW_TEAM_AVATAR_GAP_PX = 17
export const SENSEMAKER_OVERVIEW_TEAM_AVATAR_BG = '#008cd0'
export const SENSEMAKER_OVERVIEW_TEAM_NAME_COLOR = '#23262f'
export const SENSEMAKER_OVERVIEW_TEAM_NAME_SIZE_PX = 18
export const SENSEMAKER_OVERVIEW_TEAM_NAME_LINE_HEIGHT_PX = 28
export const SENSEMAKER_OVERVIEW_TEAM_NAME_LETTER_SPACING_PX = -0.4395
export const SENSEMAKER_OVERVIEW_TEAM_JOINED_COLOR = '#6b7a90'
export const SENSEMAKER_OVERVIEW_TEAM_JOINED_SIZE_PX = 13
export const SENSEMAKER_OVERVIEW_TEAM_JOINED_LINE_HEIGHT_PX = 19.5
export const SENSEMAKER_OVERVIEW_TEAM_NAME_TO_JOINED_GAP_PX = 4
export const SENSEMAKER_OVERVIEW_TEAM_ROLE_BADGE_HEIGHT_PX = 26

export const SENSEMAKER_OVERVIEW_TEAM_ROLE_STYLES = {
  ADMIN: { bg: '#e3f2fd', border: '#3285d7', color: '#1976d2', label: 'Admin' },
  EDITOR: { bg: '#fef3c7', border: '#f59e0b', color: '#92400e', label: 'Editor' },
  VIEWER: { bg: '#edf2f8', border: '#707f8b', color: '#707f8b', label: 'Viewer' },
} as const
